import cn from 'classname';
import React, { Component } from 'react';
import './TotalCell.less';

class TotalCell extends Component {
	constructor(props) {
		super(props);
		this.state = { commentsList: [] };
		this.updateCommentsList = this.updateCommentsList.bind(this);
	}
	updateCommentsList() {
		const { affiliate_id, offer_id } = this.props.data;
		if (affiliate_id) {
			this.props.getCommentsList({ affiliate_id, offer_id })
				.then(data => this.setState({ commentsList: data }));
		}
	}

	render() {
		const { row_number, setActiveRow, activeRowNumber, data } = this.props;
		const { offer_id, affiliate_id } = data;

		const needRenderData = !offer_id && !affiliate_id;

		return (
			<div
				className={cn({ 'table_cell': true, 'active': row_number === activeRowNumber, 'total_cell': true })}
				onMouseEnter={() => { setActiveRow(row_number); this.updateCommentsList(); }}
				onMouseLeave={setActiveRow.bind(null, -1)}
			>
				{
					needRenderData &&
					<div className="rows-container">
						<div className="first-row">
							<span title="affiliateIdsWithPayoutChangeWithApprovedLeads">
								{data.affiliateIdsWithPayoutChangeWithApprovedLeads.length }
							</span>
							<span
								className="approved-number"
								title="approvedLeadsCountByAffiliatesWithPayoutChange"
							>
								{ data.approvedLeadsCountByAffiliatesWithPayoutChange }
							</span>
							<span
								className="new"
								title="affiliateIdsWithPayoutChangeWithoutApprovedLeads"
							>
								{data.affiliateIdsWithPayoutChangeWithoutApprovedLeads.length }
							</span>
						</div>
					</div>
				}
			</div>
		);
	}
}

export default TotalCell;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-start/TotalCell.js